import { RunningTimer } from '../contexts/TimerContext';
import { elapsedSecondsSince, formatClock } from './timer';

/** Tab title while a timer runs, e.g. "⏱ 12:34 · Write report". */
export const formatTimerTitle = (elapsedSeconds: number, title: string): string =>
  `⏱ ${formatClock(elapsedSeconds)} · ${title}`;

/** With several timers the most recently started one is shown. */
export const pickPrimaryTimer = (timers: RunningTimer[]): RunningTimer | null =>
  timers.reduce<RunningTimer | null>((latest, timer) => {
    if (!latest) return timer;
    return elapsedSecondsSince(timer.startedAt) < elapsedSecondsSince(latest.startedAt) ? timer : latest;
  }, null);
